import xdcLogo from '../assets/networks-assets/xdc-inverted-primary-icon.svg'
import ccdLogo from '../assets/networks-assets/Concordium Symbol_White.svg'
import campLogo from '../assets/networks-assets/campnetwork.png'
import starknetLogo from '../assets/networks-assets/starknetLogo.png'
import hederaLogo from '../assets/networks-assets/Hedera-Icon-Dark.svg'
import euroeLogo from '../assets/networks-assets/EUROe_Symbol_White.svg'
import ethLogo from '../assets/networks-assets/eth logo.png'

import { generateHederaScanUrl } from '../utils/generateHederaScanUrl'
import { generateXdcScanUrl } from '../utils/generateXdcScanNetworkUrl'
import { generateCcdExplorerUrl } from '../utils/generateCcdExplorerUrl'
import { generateCampScanUrl } from '../utils/generateCampScanUrl'
import { generateStrkScanUrl } from '../utils/generateStrkScanUrl'
import { MAINNET, TESTNET } from '@concordium/react-components'
import { isProd } from '../utils/isProd'

export const NET = isProd ? MAINNET : TESTNET

export const CONCORDIUM = 'concordium'
export const POLYGON = 'polygon'
export const XDC = 'xdc'
export const CAMP = 'camp'
export const CCD = 'ccd'
export const STRK = 'strk'
export const ETH = 'eth'
export const STARKNET = 'starknet'
export const HEDERA = 'hedera'
export const HBAR = 'hbar'

// order matters for token display priority in wallet
export const allowedTokens = ['CCD', 'HBAR', 'STRK', 'ETH', 'XDC']

export const NETWORK_CONFIG = {
  hedera: {
    label: 'Hedera',
    logo: hederaLogo,
    tokens: {
      HBAR: {
        gasFee: 1,
        minWithdraw: 10,
        logo: hederaLogo,
        withdrawPlaceholder: '0x0000....00000',
      },
    },
    explorer: (type, value) =>
      generateHederaScanUrl(
        type === 'address'
          ? 'account'
          : type === 'contract'
            ? 'contract'
            : 'transaction',
        value
      ),
  },

  xdc: {
    label: 'XDC',
    logo: xdcLogo,
    tokens: {
      XDC: {
        gasFee: 0.1,
        minWithdraw: 30,
        logo: xdcLogo,
      },
    },
    explorer: (type, value) =>
      generateXdcScanUrl(type === 'transaction' ? 'tx' : 'address', value),
  },

  camp: {
    label: 'CAMP',
    logo: campLogo,
    tokens: {
      CAMP: {
        gasFee: 0.00001,
        minWithdraw: 0.001,
        logo: campLogo,
      },
    },
    explorer: (type, value) =>
      generateCampScanUrl(type === 'transaction' ? 'tx' : 'address', value),
  },

  concordium: {
    label: 'Concordium',
    logo: ccdLogo,
    tokens: {
      CCD: {
        gasFee: 0,
        minWithdraw: 100,
        logo: ccdLogo,
      },
      EUROe: {
        gasFee: 0,
        minWithdraw: 5,
        logo: euroeLogo,
      },
    },
    explorer: (type, value) =>
      generateCcdExplorerUrl(
        type === 'address' ? (value.length < 6 ? 'contract' : 'account') : type,
        value
      ),
  },

  starknet: {
    label: 'Starknet',
    logo: starknetLogo,
    tokens: {
      STRK: {
        gasFee: 0,
        minWithdraw: 10,
        logo: starknetLogo,
      },
      ETH: {
        gasFee: 0,
        minWithdraw: 0.001,
        logo: ethLogo,
      },
    },
    explorer: (type, value) =>
      generateStrkScanUrl(
        type === 'transaction' ? 'transaction' : 'contract',
        value
      ),
  },
}
